import { Button } from '@/components/ui/button';
import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { RapidReconStep } from '@/models/types';
import { Wrench } from 'lucide-react';
import { RAPID_RECON_STEP_OPTIONS_MAP } from './rapid-recon-step-selector';

export const RapidReconIcon = ({ className }: { className?: string }) => {
  return <Wrench className={cn('size-3.5', className)} />;
};

export const RapidReconStepBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
}: {
  value: RapidReconStep;
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Status</p>
        </>
      )}
      {RAPID_RECON_STEP_OPTIONS_MAP.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            RAPID_RECON_STEP_OPTIONS_MAP.find(
              (option) => option.value === value,
            )?.label
          }
        </p>
      )}
    </Button>
  );
};
